import api from "api/apiReducer";
import app from "app/App/reducer";

const rootReducer = {
    api,
    app,
};

export default rootReducer;
